import {
  IBrokerFrontendBootResponseSchema,
  IPartnerFrontendBootResponseSchema,
} from "@/types/frontendBoot.types";
import { apiRequest } from "@repo/api-services/Axios";
import { CACHE_KEYS } from "@repo/api-services/CacheKeys";
import { useQuery } from "@tanstack/react-query";

function useFrontendBoot() {
  const whichPartner = import.meta.env.DEV
    ? "rupenetsol"
    : location.host?.split(".")?.[0];

  // QUERIES FOR PARTNER AND BROKER
  const partnerFrontendBootService = useQuery({
    queryKey: [...CACHE_KEYS.PARTNER_FRONTEND_BOOT, whichPartner],
    queryFn: () => {
      return apiRequest
        .get(`/partner/${whichPartner}/frontend-boot`)
        .then((response) => {
          if (response.data.name === "AxiosError") {
            return {};
          } else {
            return response.data;
          }
        });
    },
    enabled: import.meta.env.VITE_USER === "partner" ? true : false,
  });

  const frontendBootService = useQuery({
    queryKey: [...CACHE_KEYS.FRONTEND_BOOT],
    queryFn: () => {
      return apiRequest.get("/frontend-boot").then((res) => {
        if (res.data.name === "AxiosError") {
          return {};
        } else {
          return res.data;
        }
      });
    },
    enabled: import.meta.env.VITE_USER === "broker" ? true : false,
  });

  const partnerFrontendBoot: IPartnerFrontendBootResponseSchema =
    partnerFrontendBootService?.data?.data;
  const brokerFrontendBoot: IBrokerFrontendBootResponseSchema =
    frontendBootService?.data?.data;

  const logo =
    import.meta.env.VITE_USER === "broker"
      ? brokerFrontendBoot?.settings?.general?.logo?.original_url
      : partnerFrontendBoot?.logo?.original_url;

  return {
    logo,
    partnerFrontendBoot,
    brokerFrontendBoot,
    frontendBootService,
    partnerFrontendBootService,
  };
}

export default useFrontendBoot;
